import { useEffect } from 'react'
import Button from './Shared/Elements/Button'

const ScrollToTopButton = () => {
  // useEffect(() => {
  //   const scrollContainer = document.querySelector(
  //     '[data-scroll-container]'
  //   )
  //   if (!scrollContainer) return

  //   const handleScroll = () => {
  //     setShow(scrollContainer.scrollTop > 2000)
  //   }

  //   scrollContainer.addEventListener('scroll', handleScroll)
  //   return () =>
  //     scrollContainer.removeEventListener('scroll', handleScroll)
  // }, [])

  const scrollToTop = () => {
    const scrollContainer = document.querySelector(
      '[data-scroll-container]'
    )
    if (scrollContainer) {
      scrollContainer.scrollTo({ top: 0, behavior: 'smooth' })
    }
  }

  return (
    <Button onClick={scrollToTop} icon="arrow up">
      Scroll to top
    </Button>
  )
}

export default ScrollToTopButton
